import { IconCheckCircleFilled } from '@iwoca/icons';
import classNames from 'classnames';

import styles from './StatusIcons.module.css';

const Completed = () => {
    return (
        <span
            className={classNames(styles.status, styles.completedStatus)}
            data-testid="completed-status"
        >
            <IconCheckCircleFilled
                className={classNames(styles.statusIcon, styles.completedIcon)}
                height={20}
                width={20}
            />
            Completed
        </span>
    );
};

// eslint-disable-next-line import/no-default-export
export default Completed;
